import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import SensorData from './sensor-data';
import SensorDataDetail from './sensor-data-detail';
import SensorDataUpdate from './sensor-data-update';
import SensorDataDeleteDialog from './sensor-data-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={SensorDataUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={SensorDataUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={SensorDataDetail} />
      <ErrorBoundaryRoute path={match.url} component={SensorData} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={SensorDataDeleteDialog} />
  </>
);

export default Routes;
